/**
 * /me/loans/schedule — Session 3d PR 16.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyLoanRepaymentSchedulePage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-loan-schedule", employeeId],
    queryFn: () => session3dApi.listLoanSchedule(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.loan-schedule.title", "Loan Repayment Schedule")}
        subtitle={t("me.loan-schedule.subtitle", "Installment-by-installment schedule for a specific loan.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.loan-schedule.title", "Loan Repayment Schedule"),
          window_label: t("me.loan-schedule.window", "by application"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.loan-schedule.ask_khidmat", "When is my next loan installment due?")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.loan-schedule.detail_note",
                "Installment-level schedule for a chosen loan. Pass ?application_id=<uuid> to view. Read-only — payments are handled via payroll deductions.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
